<template>
    <div>
        <AppHeader
            :title="breadcrumbs ? breadcrumbs[breadcrumbs.length - 1].text : ''"
        >
            <DLocaleToggle
                v-if="user && user.name"
                :user-id="user.id"
            />
            <DUserDropdown
                v-if="user && user.name"
                :user-name="user.name"
                :user-id="user.id"
            />
        </AppHeader>
    </div>
</template>

<script>
import AppHeader from '~@/Components/App/Header/AppHeader'
import DLocaleToggle from '~@/Components/App/Header/DLocaleToggle'
import DUserDropdown from '~@/Components/App/Header/DUserDropdown'
import { usePage } from '@inertiajs/vue3'

export default {
    name: 'Header',
    components: {
        AppHeader,
        DLocaleToggle,
        DUserDropdown
    },
    props: {
        breadcrumbs: {
            type: Array,
            default: () => { return [] }
        }
    },
    computed: {
        user () {
            return usePage().props.auth.user
        }
    }
}
</script>
